import styled from 'styled-components';

import { BaseArrowDown } from '../../svg/ArrowDown';
import { breakpoints } from '../../constants';
import { convertHexToRGBA } from '../../utils';

interface IProps {
    className?: string;
    onClick?(): void;
}

const BaseNavArrow = ({ className, onClick }: IProps) => (
    <div className={className} role="button" onClick={onClick}>
        <BaseArrowDown />
    </div>
);

interface IStyledProps {
    direction: 'left' | 'right';
    backgroundColor: string;
}

export const NavArrow = styled(BaseNavArrow)<IStyledProps>`
    width: 30px;
    background: linear-gradient(
        to ${(props) => props.direction},
        ${(props) => convertHexToRGBA(props.backgroundColor, 0)},
        ${(props) => props.backgroundColor} 20%
    );
    position: absolute;
    top: 0;
    left: ${(props) => (props.direction === 'left' ? 0 : 'auto')};
    right: ${(props) => (props.direction === 'right' ? 0 : 'auto')};
    height: 100%;

    svg {
        transform: translateX(-50%)
            rotate(
                ${(props) => (props.direction === 'left' ? '90deg' : '-90deg')}
            );
        width: 15px;
        height: 15px;
        position: absolute;
        left: 50%;
        top: 35%;
    }

    @media (${breakpoints.mediumMin}) {
        display: none;

        svg {
            top: 55%;
        }
    }
`;
